import React, { useContext } from 'react'
import { Link } from 'react-router-dom'
import { createPortal } from 'react-dom'
import { CSSTransition } from 'react-transition-group'
import { GlobalContext } from '../../context/GlobalState'
import Loading from '../Loading'
import styles from './Modal.module.css'

const ManageListModal = ({ showManageListModal, setShowManageListModal, setShowEditModal, selectedList }) => {
  const context = useContext(GlobalContext)

  /* Delete list via context and close modal */
  const deleteBttn = async e => {
    context.deleteList(selectedList.listID)
    setShowManageListModal(false)
  }

  /* Edit List, close this modal & have parent open editListModal */
  const edit = () => {
    setShowManageListModal(false)
    context.setError('')
    context.setStatus('idle')
    setShowEditModal(true)
  }

  /* Cancel and close modal */
  const cancel = () => {
    setShowManageListModal(false)
    context.setError('')
    context.setStatus('idle')
  }

  return showManageListModal ? createPortal
  (
    <CSSTransition
      in={showManageListModal}
      timeout={{ enter: 0, exit: 300 }}
      unmountOnExit
    >
      <div className="modal">
        {context.status === 'pending' ? 
            <Loading /> : (
        <div className="modal-content">
          <div className="modal-header">
            <h4>Manage List</h4>
          </div>
          <form>
            {context.status === 'error' && <p style={{color:'red'}}>{context.error}</p>}
            <input type="button" className={`${styles.standard_bttn} ${styles.w100}`} value="Edit" onClick={edit}></input>
            <Link to={`/share/${selectedList.listID}`}><input type="button" className={`${styles.share_bttn} ${styles.w100}`} value="Share"></input></Link>
            <input type="button" className={`${styles.delete_bttn} ${styles.w100}`} value="Delete" onClick={deleteBttn}></input>
            <input type="button" className={`${styles.cancel_bttn} ${styles.w100}`} value="Cancel" onClick={cancel}></input>
          </form>
        </div>
        )}
      </div>
    </CSSTransition>,
    document.body
  )
  : null
}

export default ManageListModal